import React from "react";

import EasySolutions from "../components/services/easySolutions";
import ItSolutions from "../components/services/itSolution";
import Funfact from "../components/general/funfact";
import PopSolutions from "../components/services/popSolution";
import BrandCarousel from "../components/general/brandCarousel";
import CallToAction from "../components/general/callToAction";
import { initScrollReveal } from "../helpers/scrollReveal";

const Services = () => {
  React.useEffect(() => {
    const cleanup = initScrollReveal();
    return cleanup;
  }, []);

  return (
  <>

    {/* <PageHeader title="Our Services" breadcrumb="Services" /> */}

    <EasySolutions />

    <ItSolutions />

    <Funfact />

    <PopSolutions />

    <BrandCarousel />

    <CallToAction />

  </>
  );
}

export default Services;